export default __webpack_public_path__ + "static/media/ic_copy.b8a1365a.svg";